import jsonSKY from './wonderwall-project-SKY.json';
import jsonDGO from './wonderwall-project-DGO.json';
import { APP_THEME, isCustomSkinActive } from '../utils/env';

const root = document.documentElement;

// passing colors to RGBA in order that you need some transparency
function hexToRgba(hex, alpha) {
  const r = Number.parseInt(hex.slice(1, 3), 16);
  const g = Number.parseInt(hex.slice(3, 5), 16);
  const b = Number.parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

if (isCustomSkinActive) {
  const theme = APP_THEME;
  const json = theme === 'skymais' ? jsonSKY : jsonDGO; // DGO default

  // Neutral Texts
  root.style.setProperty('--neutral-text-primary', json.colors.neutralTextPrimary);
  root.style.setProperty('--neutral-text-secondary', json.colors.neutralTextSecondary);
  root.style.setProperty('--neutral-text-disable', json.colors.neutralTextDisable);
  root.style.setProperty('--neutral-text-active', json.colors.neutralTextActive);

  // Neutral Texts Cross
  root.style.setProperty('--neutral-text-cross-white-primary', json.colors.neutralTextCrossWhitePrimary);
  root.style.setProperty('--neutral-text-cross-white-secondary', json.colors.neutralTextCrossWhiteSecondary);
  root.style.setProperty('--neutral-text-cross-gray', json.colors.neutralTextCrossGray);
  root.style.setProperty('--neutral-text-cross-black-primary', json.colors.neutralTextCrossBlackPrimary);
  root.style.setProperty('--neutral-text-cross-black-secondary', json.colors.neutralTextCrossBlackSecondary);

  // Neutral Background
  root.style.setProperty('--neutral-bg-primary', json.colors.neutralBgPrimary);
  root.style.setProperty('--neutral-bg-primary-opacity-0', hexToRgba(json.colors.neutralBgPrimary, 0));
  root.style.setProperty('--neutral-bg-primary-opacity-10', hexToRgba(json.colors.neutralBgPrimary, 0.1));
  root.style.setProperty('--neutral-bg-primary-opacity-30', hexToRgba(json.colors.neutralBgPrimary, 0.3));
  root.style.setProperty('--neutral-bg-primary-opacity-40', hexToRgba(json.colors.neutralBgPrimary, 0.4));
  root.style.setProperty('--neutral-bg-primary-opacity-50', hexToRgba(json.colors.neutralBgPrimary, 0.5));
  root.style.setProperty('--neutral-bg-primary-opacity-60', hexToRgba(json.colors.neutralBgPrimary, 0.6));
  root.style.setProperty('--neutral-bg-primary-opacity-80', hexToRgba(json.colors.neutralBgPrimary, 0.8));
  root.style.setProperty('--neutral-bg-primary-opacity-85', hexToRgba(json.colors.neutralBgPrimary, 0.85));
  root.style.setProperty('--neutral-bg-primary-opacity-90', hexToRgba(json.colors.neutralBgPrimary, 0.9));
  root.style.setProperty('--neutral-bg-primary-opacity-100', hexToRgba(json.colors.neutralBgPrimary, 1));
  root.style.setProperty('--neutral-bg-secondary', json.colors.neutralBgSecondary);
  root.style.setProperty('--neutral-bg-tertiary', json.colors.neutralBgTertiary);
  root.style.setProperty('--neutral-bg-disable', json.colors.neutralBgDisable);
  root.style.setProperty('--neutral-bg-active', json.colors.neutralBgActive);
  root.style.setProperty('--neutral-bg-active-opacity-30', hexToRgba(json.colors.neutralBgActive, 0.3));

  // Hover Neutral Background
  root.style.setProperty('--neutral-hover-bg-primary', json.colors.neutralHoverBgPrimary);
  root.style.setProperty('--neutral-hover-bg-secondary', json.colors.neutralHoverBgSecondary);
  root.style.setProperty('--neutral-hover-bg-tertiary', json.colors.neutralHoverBgTertiary);
  root.style.setProperty('--neutral-hover-bg-disable', json.colors.neutralHoverBgDisable);
  root.style.setProperty('--neutral-hover-bg-active', json.colors.neutralHoverBgActive);

  // Neutral Background Cross
  root.style.setProperty('--neutral-bg-cross-white-primary', json.colors.neutralBgCrossWhitePrimary);
  root.style.setProperty('--neutral-bg-cross-white-primary-opacity-20', hexToRgba(json.colors.neutralBgCrossWhitePrimary, 0.2));
  root.style.setProperty('--neutral-bg-cross-white-primary-opacity-30', hexToRgba(json.colors.neutralBgCrossWhitePrimary, 0.3));
  root.style.setProperty('--neutral-bg-cross-white-primary-opacity-40', hexToRgba(json.colors.neutralBgCrossWhitePrimary, 0.4));
  root.style.setProperty('--neutral-bg-cross-white-secondary', json.colors.neutralBgCrossWhiteSecondary);
  root.style.setProperty('--neutral-bg-cross-gray', json.colors.neutralBgCrossGray);
  root.style.setProperty('--neutral-bg-cross-black-primary', json.colors.neutralBgCrossBlackPrimary);
  root.style.setProperty('--neutral-bg-cross-black-primary-opacity-0', hexToRgba(json.colors.neutralBgCrossBlackPrimary, 0));
  root.style.setProperty('--neutral-bg-cross-black-primary-opacity-001', hexToRgba(json.colors.neutralBgCrossBlackPrimary, 0.01));
  root.style.setProperty('--neutral-bg-cross-black-primary-opacity-10', hexToRgba(json.colors.neutralBgCrossBlackPrimary, 0.1));
  root.style.setProperty('--neutral-bg-cross-black-primary-opacity-15', hexToRgba(json.colors.neutralBgCrossBlackPrimary, 0.15));
  root.style.setProperty('--neutral-bg-cross-black-primary-opacity-52', hexToRgba(json.colors.neutralBgCrossBlackPrimary, 0.52));
  root.style.setProperty('--neutral-bg-cross-black-primary-opacity-40', hexToRgba(json.colors.neutralBgCrossBlackPrimary, 0.4));
  root.style.setProperty('--neutral-bg-cross-black-primary-opacity-70', hexToRgba(json.colors.neutralBgCrossBlackPrimary, 0.7));
  root.style.setProperty('--neutral-bg-cross-black-primary-opacity-85', hexToRgba(json.colors.neutralBgCrossBlackPrimary, 0.85));
  root.style.setProperty('--neutral-bg-cross-black-primary-opacity-90', hexToRgba(json.colors.neutralBgCrossBlackPrimary, 0.9));
  root.style.setProperty('--neutral-bg-cross-black-secondary', json.colors.neutralBgCrossBlackSecondary);

  // Neutral Border
  root.style.setProperty('--neutral-border-primary', json.colors.neutralBorderPrimary);
  root.style.setProperty('--neutral-border-secondary', json.colors.neutralBorderSecondary);

  // Neutral Border Cross
  root.style.setProperty('--neutral-border-cross-black-primary', json.colors.neutralBorderCrossBlackPrimary);
  root.style.setProperty('--neutral-border-cross-black-secondary', json.colors.neutralBorderCrossBlackSecondary);
  root.style.setProperty('--neutral-border-cross-white-primary', json.colors.neutralBorderCrossWhitePrimary);
  root.style.setProperty('--neutral-border-cross-white-secondary', json.colors.neutralBorderCrossWhiteSecondary);

  // Main
  root.style.setProperty('--main-text-primary', json.colors.mainTextPrimary);
  root.style.setProperty('--main-bg-primary', json.colors.mainBgPrimary);
  root.style.setProperty('--main-bg-active', json.colors.mainBgActive);
  root.style.setProperty('--main-border', json.colors.mainBorder);
  root.style.setProperty('--main-brand', json.colors.mainBrand);

  // Main Hover Background
  root.style.setProperty('--main-hover-bg-primary', json.colors.mainHoverBgPrimary);
  root.style.setProperty('--main-hover-bg-active', json.colors.mainHoverBgActive);

  // Complementary
  root.style.setProperty('--complementary-text-primary', json.colors.complementaryTextPrimary);
  root.style.setProperty('--complementary-bg-primary', json.colors.complementaryBgPrimary);
  root.style.setProperty('--complementary-hover-bg-primary', json.colors.complementaryHoverBgPrimary);
  root.style.setProperty('--complementary-border', json.colors.complementaryBorder);
  root.style.setProperty('--complementary-brand', json.colors.complementaryBrand);

  // Success
  root.style.setProperty('--success-text-primary', json.colors.successTextPrimary);
  root.style.setProperty('--success-bg-primary', json.colors.successBgPrimary);
  root.style.setProperty('--success-hover-bg-primary', json.colors.successHoverBgPrimary);
  root.style.setProperty('--success-border', json.colors.successBorder);

  // Warning
  root.style.setProperty('--warning-text-primary', json.colors.warningTextPrimary);
  root.style.setProperty('--warning-bg-primary', json.colors.warningBgPrimary);
  root.style.setProperty('--warning-hover-bg-primary', json.colors.warningHoverBgPrimary);
  root.style.setProperty('--warning-border', json.colors.warningBorder);

  // Error
  root.style.setProperty('--error-text-primary', json.colors.errorTextPrimary);
  root.style.setProperty('--error-bg-primary', json.colors.errorBgPrimary);
  root.style.setProperty('--error-hover-bg-primary', json.colors.errorHoverBgPrimary);
  root.style.setProperty('--error-border', json.colors.errorBorder);

  // Informative
  root.style.setProperty('--informative-text-primary', json.colors.informativeTextPrimary);
  root.style.setProperty('--informative-bg-primary', json.colors.informativeBgPrimary);
  root.style.setProperty('--informative-hover-bg-primary', json.colors.informativeHoverBgPrimary);
  root.style.setProperty('--informative-border', json.colors.informativeBorder);

  // Avatar
  root.style.setProperty('--avatar-bg-1', json.colors.avatarBg1);
  root.style.setProperty('--avatar-bg-2', json.colors.avatarBg2);
  root.style.setProperty('--avatar-bg-3', json.colors.avatarBg3);
  root.style.setProperty('--avatar-bg-4', json.colors.avatarBg4);
  root.style.setProperty('--avatar-bg-5', json.colors.avatarBg5);

  // Opacity White
  root.style.setProperty('--opacity-white-weakest', json.colors.opacityWhiteWeakest);
  root.style.setProperty('--opacity-white-weak', json.colors.opacityWhiteWeak);
  root.style.setProperty('--opacity-white-medium', json.colors.opacityWhiteMedium);
  root.style.setProperty('--opacity-white-strong', json.colors.opacityWhiteStrong);
  root.style.setProperty('--opacity-white-strongest', json.colors.opacityWhiteStrongest);

  // Opacity Black
  root.style.setProperty('--opacity-black-weakest', json.colors.opacityBlackWeakest);
  root.style.setProperty('--opacity-black-weak', json.colors.opacityBlackWeak);
  root.style.setProperty('--opacity-black-medium', json.colors.opacityBlackMedium);
  root.style.setProperty('--opacity-black-strong', json.colors.opacityBlackStrong);
  root.style.setProperty('--opacity-black-strongest', json.colors.opacityBlackStrongest);
}
